import React from 'react';
import './PageTransition.css';

// Simplified PageTransition - just wraps children without adding loading screens
// Individual pages handle their own loading state using the global store
const PageTransition = ({ children }) => {
  return (
    <div className="page-transition">
      {children}
    </div>
  );
};

export default PageTransition;
